module.exports = __webpack_public_path__ + "img/ado.43881573.svg";